import { ICurrency, IPrice } from '@/interfaces';
export const getLocalToken = () => localStorage.getItem('token');

export const saveLocalToken = (token: string) => localStorage.setItem('token', token);

export const removeLocalToken = () => localStorage.removeItem('token');

export default function getBrowserLocale(options = {}) {
  const defaultOptions = { countryCodeOnly: false }

  const opt = { ...defaultOptions, ...options }

  const navigatorLocale =
    navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator.language

  if (!navigatorLocale) {
    return undefined
  }

  const trimmedLocale = opt.countryCodeOnly
    ? navigatorLocale.trim().split(/-|_/)[0]
    : navigatorLocale.trim()

  return trimmedLocale
}

export function indexOfCb(array,  callback){
  for (var i = 0; i < array.length; i++) {
    if ( callback(array[i])){
      return i;
    }
  }
  return -1;
};


export function getCurrentDatetime(){
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const hour = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const milliseconds = date.getMilliseconds();

  const offset = -1*Math.trunc(date.getTimezoneOffset() / 60);

  return `${year}-`;
}

export function formatValueWithCurrency(value: number, currency: ICurrency) {
  const style_format = currency.style_format;
  const code = currency.code;
  const fmt = new Intl.NumberFormat(style_format, {
      style: "currency",
      currency: code,
  }).format(value);
  return `${code} ${fmt}`;
}

export function formatPrice(price: IPrice) {
  const value = price.value;
  const style_format = price.style_format;
  const code = price.currency_code;
  const fmt = new Intl.NumberFormat(style_format, {
      style: "currency",
      currency: code,
  }).format(value);
  return `${code} ${fmt}`;
}